import * as React from 'react'
import { PageTitle } from 'uiComponents/typography'
import './index.scss'
import { RELEASED_PAGE } from './htmlComponents'
import { useTranslation } from 'translations'

function ReleaseNotes() {
    const { t } = useTranslation()
    return (
        <div>
            <PageTitle>{t('releaseNotes.title')}</PageTitle>
            <div
                className="content"
                dangerouslySetInnerHTML={{
                    __html: RELEASED_PAGE,
                }}
             />
        </div>
    )
}

export default ReleaseNotes
